<app-main-template>
  <div class="search-page-wrapper">
    @if (dataLoaded && pageData) {
      @if (!(isMobileVersion | async)) {
        <div class="categories-wrapper">
          <app-categories [availableItems]="pageData.itemsCount" [showMobileCategories]="false"></app-categories>
        </div>
      }
      <div class="search-results-wrapper">
        @if (pageData) {
          <h1>{{ 'Search results for'|translate }} "{{ searchPrompt }}"</h1>
          <p class="items-found">{{ itemsCount | translate }}</p>
          @if (isMobileVersion | async) {
            <div class="categories-wrapper">
              <app-categories [availableItems]="pageData.itemsCount" [showMobileCategories]="true"></app-categories>
            </div>
          }
          @if (pageData.searchItems && pageData.searchItems.items.length > 0) {
            @for (item of pageData.searchItems.items; track item; let index = $index) {
              <app-search-result
                [searchItem]="item"
                [searchItemIndex]="index"
                [searchItems]="pageData.searchItems"
                [searchPrompt]="searchPrompt">
              </app-search-result>
            }
            <app-paginator
              [totalRecords]="pageData.searchItems.totalCount"
              slot="pagination"></app-paginator>
          } @else {
            <div class="no-data-wrapper">
              <i class="icon-MagnifyingGlass search-icon"></i>
              <span class="text text-lg text--semi-bold">{{ 'No results'|translate }}</span>
            </div>
          }
        }
      </div>
    } @else {
      <div class="loading-screen">
        <mat-spinner [mode]="'indeterminate'" class="bright-green"></mat-spinner>
      </div>
    }
  </div>
</app-main-template>
